import {httpService} from "@/modules/common/services"


const createVcitaXpertEntities = async (business) => {
  try {
    return await httpService.post(`platform/v1/businesses/${business.businessUid}/make_vcita_xpert_with_directory`,business)
  } catch (e) {
    return e.response.data
  }
}
const checkIncompleteXpertSignup = async (businessUid) => {
  try {
    return await httpService.get(`platform/v1/businesses/${businessUid}/check_incomplete_xpert_signup`)
  } catch (e) {
    return e.response.data
  }
}

export const xpertWizardsService = {
  createVcitaXpertEntities,
  checkIncompleteXpertSignup
};
